import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/shared/ui/kit/button";
import { CommandShortcut } from "@/shared/ui/kit/command";

type SearchTriggerButtonProps = {
  isMac: boolean;
  onOpen: () => void;
};

export function SearchTriggerButton({
  isMac,
  onOpen,
}: SearchTriggerButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      onClick={onOpen}
      className="hidden lg:flex items-center gap-2 w-full px-3 h-8 bg-accent rounded-lg text-muted-foreground text-sm hover:bg-accent/80 justify-between"
    >
      <div className="flex items-center gap-2">
        <Search className="w-4 h-4" />
        <span>{t("search.searchPlaceholder")}</span>
      </div>
      <CommandShortcut className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
        {isMac ? "⌘" : "Ctrl"}K
      </CommandShortcut>
    </Button>
  );
}
